exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-title{border-bottom:1px solid #D8D8D8;color:#000000;font-family:'SF-Pro-Display-Bold';font-size:28px;padding-bottom:14px;margin-top:50px;margin-bottom:12px;display:flex;align-content:center;justify-content:center;align-items:center}.page-title .page-title-text{text-align:left;flex:1}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/PageTitle/style.scss
// module id = 1493
// module chunks = 0